<template>
  <b-row v-show="applied" no-gutters class="automated-discount-notice mb-4">
    <b-col class="text-right">
      <small class="badge badge-success-light">{{ label }}</small>
      <span role="status" class="sr-only">{{ applied ? label : '' }}</span>
    </b-col>
  </b-row>
</template>

<script>
export default {
  name: 'DpAutomatedDiscountNotice',
  props: {
    label: {
      type: String,
      required: true,
    },
    applied: {
      type: Boolean,
      default: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.automated-discount-notice {
  margin-top: 0.75rem;
}
</style>
